// extracted by mini-css-extract-plugin
export default {"view":"View_view__KVUAF"};